import { useEffect, useState } from 'react';
import { PostUtil } from 'src/pages/new-post-new/post-util';
import YoutubePostVideoPreview from './youtube-post-video-preview.component';

const YoutubePostPreview = ({ data }) => {
  const [isVideo, setIsVideo] = useState(false);
  useEffect(() => {
    if (!data) return;
    if (data?.media_data?.count == 1 && data?.media_data.media_data[0].type === PostUtil.MediaType.VIDEO) {
      setIsVideo(true);
    }
  }, [data]);
  return isVideo && <YoutubePostVideoPreview data={data} />;
};

export default YoutubePostPreview;
